var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 178 158",
    style: {
      enableBackground: "new 0 0 178 158"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BCBCBC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142,60.1l14.4-14.4c0.6-0.6,0.9-1.4,0.8-2.3c-0.1-0.8-0.6-1.6-1.4-2L138.5,32c-1.3-0.7-2.9-0.2-3.6,1.1 c-0.7,1.3-0.2,2.9,1.1,3.6l14.2,7.8l-12.3,12.3L93.4,32.5l12.3-12.3l12.5,6.8c1.3,0.7,2.9,0.2,3.6-1.1c0.7-1.3,0.2-2.9-1.1-3.6 l-14.2-7.8c-1-0.6-2.3-0.4-3.2,0.5L89,29.3L74.6,15c-0.8-0.8-2.1-1-3.2-0.5l-49.2,27c-0.7,0.4-1.2,1.1-1.4,2 c-0.1,0.8,0.2,1.7,0.8,2.3L36,60.1L21.7,74.5c-0.6,0.6-0.9,1.4-0.8,2.3c0.1,0.8,0.6,1.6,1.4,2l14.9,8.2v27.3c0,1,0.5,1.9,1.4,2.3 l49.2,27c0.4,0.2,0.8,0.3,1.3,0.3s0.9-0.1,1.3-0.3l49.2-27c0.9-0.5,1.4-1.4,1.4-2.3V86.9l14.9-8.2c0.7-0.4,1.2-1.1,1.4-2 c0.1-0.8-0.2-1.7-0.8-2.3L142,60.1z M89,84.1l-43.7-24l43.7-24l43.7,24L89,84.1z M72.3,20.1l12.3,12.3L40.3,56.8L27.9,44.5 L72.3,20.1z M40.3,63.4l44.3,24.4l-12.3,12.3L27.9,75.7L40.3,63.4z M135.5,112.6l-43.9,24.1v-27.2c0-1.5-1.2-2.7-2.7-2.7 c-1.5,0-2.7,1.2-2.7,2.7v27.2l-43.9-24.1V89.8l29,15.9c0.4,0.2,0.8,0.3,1.3,0.3c0.7,0,1.4-0.3,1.9-0.8L89,90.9l14.4,14.4 c0.5,0.5,1.2,0.8,1.9,0.8c0.4,0,0.9-0.1,1.3-0.3l29-15.9V112.6z M105.7,100.1L93.4,87.7l44.3-24.4l12.3,12.3L105.7,100.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/emptyList.ae1f3d4a198a613ef504c8cd198a24ba.svg";
export { ForwardRef as ReactComponent };